module.exports = __webpack_public_path__ + "img/no-image.12a67159.svg";